const FacebookIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="url(#paint0_linear_305_1637)"/>
        <path d="M15.7241 15.0583L16.1683 12.2358H13.3894V10.405C13.3894 9.63264 13.7769 8.87936 15.0216 8.87936H16.2857V6.47642C16.2857 6.47642 15.1389 6.28571 14.0431 6.28571C11.7534 6.28571 10.2584 7.63781 10.2584 10.0846V12.2358H7.71429V15.0583H10.2584V21.8818C10.7691 21.96 11.2916 22 11.8239 22C12.3561 22 12.8787 21.96 13.3894 21.8818V15.0583H15.7241Z" fill="white"/>
        <defs>
        <linearGradient id="paint0_linear_305_1637" x1="12" y1="2" x2="12" y2="21.9407" gradientUnits="userSpaceOnUse">
        <stop stop-color="#18ACFE"/>
        <stop offset="1" stop-color="#0163E0"/>
        </linearGradient>
        </defs>
        </svg>
        
        
);
};
export default FacebookIcon;
